import { render, staticRenderFns } from "./NotificacionGrid.vue?vue&type=template&id=52f4408a"
import script from "./NotificacionGrid.vue?vue&type=script&lang=js"
export * from "./NotificacionGrid.vue?vue&type=script&lang=js"
import style0 from "./NotificacionGrid.vue?vue&type=style&index=0&id=52f4408a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports